"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFlex = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var alignItemsStringHelper = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) { return style_utils_1.setAlignItems(props.$alignItems); });
var justifyContentStringHelper = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) { return style_utils_1.setJustifyContent(props.$justifyContent); });
exports.StyledFlex = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  text-align: ", " !important;\n\n  ", ";\n\n  ", ";\n"], ["\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  text-align: ", " !important;\n\n  ",
    ";\n\n  ",
    ";\n"])), style_utils_1.getColor("gray", 900), function (props) { return style_utils_1.setDisplay(props.$inlineFlex ? "inline-flex" : "flex"); }, function (props) { return props.$flexDirection && style_utils_1.setFlexDirection(props.$flexDirection); }, function (props) { return props.$wrap && style_utils_1.setWrap(props.$wrap); }, function (props) { return style_utils_1.escapeCss(props.$textAlign); }, function (props) {
    return Array.isArray(props.$alignItems)
        ? style_utils_1.mapArrayToMediaHelper(props.$alignItems, style_utils_1.setAlignItems, "align")
        : alignItemsStringHelper;
}, function (props) {
    return Array.isArray(props.$justifyContent)
        ? style_utils_1.mapArrayToMediaHelper(props.$justifyContent, style_utils_1.setJustifyContent, "justify")
        : justifyContentStringHelper;
});
var Flex = react_1.default.forwardRef(function (_a, ref) {
    var as = _a.as, forwardedAs = _a.forwardedAs, alignItems = _a.alignItems, flexDirection = _a.flexDirection, inlineFlex = _a.inlineFlex, justifyContent = _a.justifyContent, rtl = _a.rtl, textAlign = _a.textAlign, wrap = _a.wrap, props = __rest(_a, ["as", "forwardedAs", "alignItems", "flexDirection", "inlineFlex", "justifyContent", "rtl", "textAlign", "wrap"]);
    return (react_1.default.createElement(exports.StyledFlex, __assign({}, props, { ref: ref, as: forwardedAs || as || "div", "$alignItems": alignItems, "$flexDirection": flexDirection, "$inlineFlex": inlineFlex, "$justifyContent": justifyContent, "$textAlign": textAlign, "$rtl": rtl, "$wrap": wrap })));
});
Flex.defaultProps = {
    alignItems: "baseline",
    textAlign: "left"
};
Flex.displayName = "Flex";
exports.default = Flex;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map